import { render, staticRenderFns } from "./ContaConfiguracaoNotification.vue?vue&type=template&id=e8122d0e&scoped=true&"
import script from "./ContaConfiguracaoNotification.vue?vue&type=script&lang=js&"
export * from "./ContaConfiguracaoNotification.vue?vue&type=script&lang=js&"
import style0 from "./ContaConfiguracaoNotification.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ContaConfiguracaoNotification.vue?vue&type=style&index=1&id=e8122d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8122d0e",
  null
  
)

export default component.exports